import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api/v1',
  timeout: 15000,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

// Public API
export const getProperties = (params) => API.get('/properties', { params });
export const getPropertyBySlug = (slug) => API.get(`/properties/${slug}`);
export const getFeaturedProperties = () => API.get('/properties/featured');
export const submitLead = (data) => API.post('/leads', data);

// Admin Auth
export const adminLogin = (credentials) => API.post('/auth/login', credentials);

// Admin Properties
export const adminGetProperties = (params) => API.get('/admin/properties', { params });
export const adminCreateProperty = (data) => API.post('/admin/properties', data);
export const adminUpdateProperty = (id, data) => API.put(`/admin/properties/${id}`, data);
export const adminDeleteProperty = (id) => API.delete(`/admin/properties/${id}`);
export const adminUploadImages = (id, formData) =>
  API.post(`/admin/properties/${id}/images`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const adminUploadBrochure = (id, formData) =>
  API.post(`/admin/properties/${id}/brochure`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const adminUploadDeveloperLogo = (id, formData) =>
  API.post(`/admin/properties/${id}/developer-logo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// Admin Leads
export const adminGetLeads = (params) => API.get('/admin/leads', { params });
export const adminUpdateLeadStatus = (id, status) => API.patch(`/admin/leads/${id}/status`, { status });
export const adminExportLeads = () => API.get('/admin/leads/export', { responseType: 'blob' });

// Admin Dashboard
export const adminGetDashboard = () => API.get('/admin/dashboard');

export default API;

export const adminChangePassword = (data) => API.post('/auth/change-password', data);

export const adminResetPassword = (data) => API.post('/auth/reset-password', data);
